export const MAX_ALLOWED_SPREAD_PERCENTAGE = 25;
export const NEGATIVE_SPREAD_THRESHOLD = -50;
export const INPUT_MODE = {
    CRYPTO: 'crypto',
    FIAT: 'fiat',
};
